export default __webpack_public_path__ + "static/media/zasto_nase_sadnice.20f7f840.jpg";